/*
xrx-checkbox.tsx
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { useEffect, useState, useRef } from 'react'
import $ from 'jquery'
interface XrxcheckboxProps {
  isChecked?: boolean
  isDisabled?: boolean
  onChange?: () => void
  id: string
  label?: string,
  className?: string
}

function XrxCheckbox(props: XrxcheckboxProps){
  const [checked, setChecked] = useState(props.isChecked)
  const [disabled, setDisabled] = useState(props.isDisabled)
  const inputRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (inputRef.current) {
      $(inputRef.current).xrxcheckbox()
    }
    return(()=>{
        $('selector').xrxcheckbox('dispose');
    })
  }, [])
  useEffect(() => {
    if (inputRef.current) {
      if (checked) {
        $(inputRef.current).xrxcheckbox('setChecked')
      } else {
        $(inputRef.current).xrxcheckbox('setUnchecked')
      }
    }
  }, [checked])
  
  useEffect(() => {
    setChecked(props.isChecked)
  }, [props.isChecked])

  useEffect(() => {
    setDisabled(props.isDisabled)
  }, [props.isDisabled])

  const handleToggle = () => {
      if (!disabled && props.onChange) {
        props.onChange()
      }
  }

  return (

      <div
        id={`${props.id}`}
        className={`xrx-checkbox ${props.className ? props.className : ""}`}
        ref={inputRef}
      >
        <input type='checkbox' id={`${props.id}-input`} onMouseUp={handleToggle} {...(disabled) ? {disabled:true} : {}}/>
        {props.label && (
          <label htmlFor={`${props.id}-input`}>{props.label}</label>
        )}
      </div>
  )
}

export default XrxCheckbox